<template>
    <div class="action-updated-profile">
        <div class="title f-bold" v-html="$translate('ACTION_CONFIRMED_PROFILE')" />
        <div class="body">
            <div v-html="body" />
        </div>
    </div>
</template>
<script>
export default {
    name: 'ActionConfirmedProfile',
    props: ['message'],
    computed: {
        chat() {
            return this.$store.getters.chat
        },
        chatUser() {
            if (!this.chat) return

            return (this.chat || {}).user
        },
        body() {
            return this.$translate('ACTION_UPDATED_PROFILE_BODY')
        },
    },
}
</script>
